module.exports = __webpack_public_path__ + "media/assets/icons/reflection-modal-bg-5a1665573bbf1b842f64e613e02055d4.png";